var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconReadLoud = function SvgIconReadLoud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-read-loud_svg__Lag_1",
    viewBox: "0 0 16.4 11.9"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-read-loud_svg__st0{fill:#14143c}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 0-1.1 1c1.3 1.4 2 3.1 2 4.9s-.7 3.6-2 5l1.1 1c1.5-1.6 2.4-3.7 2.4-6s-.8-4.3-2.3-5.9ZM10.4 3.5c.6.7.9 1.5.9 2.4s-.3 1.7-.9 2.4l1.1 1c.8-.9 1.3-2.1 1.3-3.4s-.5-2.4-1.3-3.4l-1.1 1ZM4 2.7 2.8 4H0v3.6h2.8l3.1 3.6h2V.5h-2L4 2.7z",
    className: "icon-read-loud_svg__st0"
  })));
};
export default SvgIconReadLoud;